/**
 * Order service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DisputeMessageResponse } from './disputeMessageResponse';
import { DisputeDecisionResponse } from './disputeDecisionResponse';
import { DisputeReasonResponse } from './disputeReasonResponse';


export interface DisputeShared { 
    id?: number;
    reasonId?: number;
    expectedDecision?: DisputeDecisionResponse;
    reason?: DisputeReasonResponse;
    expectedDecisionId?: number;
    orderId?: number;
    disputeStatus?: DisputeShared.DisputeStatusEnum;
    terminated?: boolean;
    moderatorInvited?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    expiredAt?: Date;
    messages?: Array<DisputeMessageResponse>;
}
export namespace DisputeShared {
    export type DisputeStatusEnum = 'NEW' | 'UNDER_CONSIDERATION' | 'BUYER_CANCELLED' | 'MODERATOR_REJECTED' | 'RETURNED' | 'SELLER_ACCEPT' | 'SELLER_REJECTED' | 'SETTLED';
    export const DisputeStatusEnum = {
        NEW: 'NEW' as DisputeStatusEnum,
        UNDER_CONSIDERATION: 'UNDER_CONSIDERATION' as DisputeStatusEnum,
        BUYER_CANCELLED: 'BUYER_CANCELLED' as DisputeStatusEnum,
        MODERATOR_REJECTED: 'MODERATOR_REJECTED' as DisputeStatusEnum,
        RETURNED: 'RETURNED' as DisputeStatusEnum,
        SELLER_ACCEPT: 'SELLER_ACCEPT' as DisputeStatusEnum,
        SELLER_REJECTED: 'SELLER_REJECTED' as DisputeStatusEnum,
        SETTLED: 'SETTLED' as DisputeStatusEnum
    };
}


